import axios from 'axios'
import { DEFAULT_AXIOS_OPTIONS } from '../../../axios'
import { authRequestInterceptor } from '@/utils'

const eventApi = axios.create({
  ...DEFAULT_AXIOS_OPTIONS,
  baseURL: import.meta.env.VITE_EVENT_FUNCTION_BASE,
})

eventApi.interceptors.request.use(authRequestInterceptor)

export { eventApi }
